import { useState } from "react";
import styled from "styled-components";
import { Text } from "styles";

export default function RetractableSection({ children, title }) {
	const [open, setOpen] = useState(false);

	return (
		<Container $open={open}>
			<TitleButton type="button" $open={open} onClick={() => setOpen(value => !value)}>
				<ArrowContainer>
					<Text size={13} style={{ position: "relative", top: -2, marginRight: 10 }}>
						{open ? (
							<span dangerouslySetInnerHTML={{ __html: "&#x25BC;&#xfe0e;" }} />
						) : (
							<span dangerouslySetInnerHTML={{ __html: "&#x25b6;&#xfe0e;" }} />
						)}
					</Text>
				</ArrowContainer>
				<TitleText>{title}</TitleText>
			</TitleButton>
			<Content $open={open}>
				<ContentInner $open={open}>{children}</ContentInner>
			</Content>
		</Container>
	);
}

const Container = styled.div`
	background-color: #fff;
	margin: 10px 0;
	border-radius: 10px;
	font-size: 24px;
	width: 100%;
	box-sizing: border-box;
	border: 1px solid #eee;
	overflow: hidden;

	&:hover {
		border-color: #ddd;
	}
`;

const TitleButton = styled.button`
	display: flex;
	align-items: flex-start;
	width: 100%;
	box-sizing: border-box;
	margin: 0;
	padding: ${({ $open }) => ($open ? "30px 50px 10px" : "20px 50px")};
	border: 0;
	background: none;
	font: inherit;
	color: inherit;
	text-align: left;
	cursor: pointer;
	user-select: none;
	-webkit-user-select: none;

	@media (max-width: 768px) {
		padding: ${({ $open }) => ($open ? "30px 30px 10px" : "20px 30px")};
	}
`;

const TitleText = styled.span`
	flex: 1;
	user-select: none;
	-webkit-user-select: none;
`;

const ArrowContainer = styled.span`
	flex-shrink: 0;
	user-select: none;
	-webkit-user-select: none;

	@media (max-width: 768px) {
		width: 20px;
	}
`;

const Content = styled.div`
	display: grid;
	grid-template-rows: ${({ $open }) => ($open ? "1fr" : "0fr")};
	transition: grid-template-rows 0.35s ease;
`;

const ContentInner = styled.div`
	overflow: hidden;
	min-height: 0;
	box-sizing: border-box;
	padding: ${({ $open }) => ($open ? "10px 50px 30px" : "0 50px")};
	font-size: 22px;
	line-height: 1.2;
	cursor: text;
	user-select: text;

	@media (max-width: 768px) {
		padding: ${({ $open }) => ($open ? "10px 30px 30px" : "0 30px")};
	}
`;
